export class NewPass{
  pin: string = '';
  password: string = "";
}